module.exports = __webpack_public_path__ + "static/img/jiaofei.67019c1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/jiaofei.png
// module id = 2VK6
// module chunks = 0